/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DashboardDefinitionAclEval {
    getFixupPrototypeFunction() { return DashboardDefinitionAclEval.fixupPrototype; }

    static newInstance(model: Partial<DashboardDefinitionAclEval>): DashboardDefinitionAclEval {
        let obj = Object.assign(new DashboardDefinitionAclEval(), model);
        DashboardDefinitionAclEval.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DashboardDefinitionAclEval>): DashboardDefinitionAclEval {
        if (!model) return null;
        return DashboardDefinitionAclEval.newInstance(<DashboardDefinitionAclEval> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DashboardDefinitionAclEval) {
        if (!obj) return;

        models.DashboardDefinitionAclEval.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DashboardDefinitionAclEval): boolean {
        Object.setPrototypeOf(obj, DashboardDefinitionAclEval.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * True if user is the owner of the dashboard
     */
    is_owner: boolean;

    /**
     * Actions granted to user
     */
    granted: Array<string>;

}
